import splitNametag from '@/lib/splitNametag';
import { getCookie, setCookie, removeCookie } from 'tiny-cookie'

let loadedInfo = {};
try {
  loadedInfo = getCookie('info', JSON.parse) || {nametag: undefined};
} catch(e) {
  console.error(e);
}

export default {
  state: {
    // id of member, or null for user
    ordereeId: null,
    info: loadedInfo,
  },
  mutations: {
    setInfo(state, info) {
      state.info = info;
      setCookie('info', info, JSON.stringify);
      console.log('info->', info);
    },
    setOrdereeId(state, id) {
      state.ordereeId = id;
    }
  },
  actions: {
    setOrdereeId({commit, dispatch}, ordereeId) {
      commit('setOrdereeId', ordereeId);
      return ordereeId && dispatch('loadTeamMember', ordereeId);
    },
    updateLocalProfile({commit, state}, info) {
      // Store some info locally. This allows personalInfo
      // to be prefilled for anonymous users
      commit('setInfo', {...(state.info||{}), ...(info||{})});
    },
    updatePersonalInfo({dispatch, commit, getters}, info) {
      let u = getters.user;
      if (u) {
        return dispatch('updateProfile', {personal_info: {...u.personal_info, ...info}});
      } else {
        // Store some info locally. This allows personalInfo
        // to be prefilled for anonymous users
        commit('setInfo', {...(state.info||{}), ...(info||{})});
      }
    }
  },
  getters: {
    /**
     * Return personal info for the "current" person being ordered for.
     * @param {*} state
     */
    personalInfo(state, getters) {
      let user = getters.orderee;
      if (!user) return mungeNametag(state.info);
      let address = getters.ordereeDefaultAddress;
      // TODO not sure if it makes sense to incorporate state.info here
      let info = Object.assign({}, state.info, user.personal_info||{});
      return {
        fname: user.first_name,
        lname: user.last_name,
        name: user.first_name + ' ' + user.last_name,
        email: user.email,
        ...personalAddr(address),
        ...mungeNametag(info)
      };
    },
    personalVars: (state, getters) => getters.orderee && personalVars(getters.orderee.personal_info, getters.personalInfoSettings),
    orderee: (state, getters) => state.ordereeId ? getters.member : getters.user,

    ordereeDefaultAddress: (state, getters) => {
      if (!state.ordereeId) return;
      // Caller should ensure the team addresses are loaded
      let {default_team_address} = getters.orderee;
      // Return team address specified by the address_id, or
      // the personal address has the is_default_for_shipping,
      if (default_team_address) {
        if (!getters.teamAddresses) return null; // Team addresses not loaded yet.
        return getters.teamAddresses.find(addr => default_team_address == addr.id);
      } else {
        let userAddresses = getters.orderee.addresses || [];
        return userAddresses.find(addr => addr.is_default_for_shipping);
      }
    },
  }
}

function personalAddr(address) {
  let {line1, line2, line3, city, state, postcode} = address || {};
  let line4 = city || state || postcode ? `${city}, ${state} ${postcode}` : '';
  let [addr1, addr2, addr3, addr4] = [line1, line2, line3, line4].filter(Boolean)
  return {addr1, addr2, addr3, addr4}
}

function mungeNametag({nametag, ...info}) {
  if (nametag) info.nametag = splitNametag(nametag);
  return info;
}

// This defines the default settings new teams will see.
// The format is designed to allow simple merging using Object.assign.
const DEFAULT_SETTINGS = {
  // Fields are listed by key.
  title: {label: 'Title'},
  ph1: {label: 'Phone'},

  // Special keys: don't use these as field names!
  // Gives the list of field keys, in order.
  fields: ['title', 'ph1'],
  // Whether to ask for the address as part of the persona info
  address: true
};

function personalVars(info, settings) {
  // return a series of objects for each entry in the personal_info.
  // This basically exposes the title of well-known variables, in a
  // consistent order.

  settings = Object.assign({}, DEFAULT_SETTINGS, settings)

  let labels = {
    // These well-known variables are returned first, in this order
    title: 'Title',
    ph1: 'Phone 1',
    ph2: 'Phone 2'
  };
  info = {...info}; // make a copy
  let result = [];
  result.address = settings.address;

  for (let key of settings.fields) {
    let {label=key} = settings[key]||{}, value = info[key];
    result.push({key, label, value});
    delete info[key];
  }

  // Add all other info that has been set
  for (let key in info) {
    let label = key, value = info[key];
    if (value) result.push({key, label, value});
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/store/personalInfo.js